import {
    Group,
    Text,
} from '@mantine/core';

import {TestRunStatus} from '../types.ts';
import {TestRunStatusBadge} from './TestRunStatusBadge.tsx';

// FNP-969: the legend exists so the FAILED / ABANDONED distinction is stated ON
// THE PAGE rather than left to a tooltip an operator has to discover by hovering.
// An operator scanning this table is deciding whether to go and hunt a product
// bug; getting that wrong because two badges looked similar is the failure mode
// this module was built to prevent.
export const TestRunStatusLegend = () => {
    return (
        <Group gap={'lg'} wrap={'wrap'}>
            <Group gap={'xs'}>
                <TestRunStatusBadge status={TestRunStatus.FAILED}/>
                <Text size={'xs'} c={'dimmed'}>the test ran and did not pass — a product defect</Text>
            </Group>
            <Group gap={'xs'}>
                <TestRunStatusBadge status={TestRunStatus.ABANDONED}/>
                <Text size={'xs'} c={'dimmed'}>the canary died mid-wake and the lease expired — a harness
                                               problem, NOT a product defect</Text>
            </Group>
        </Group>
    );
};
